import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmKbPermissionsRoute: InvariantJiraRoute = {
	name: 'products-jsm-kb-permissions',
	path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
	exact: true,
};
